import React, { Component } from "react";

import Slider from "react-slick";
import "./slick-theme.less";
import "./slick.less";
import SVGIcon from "../common/svg-icon";
import PropTypes from "prop-types";

function PrevArrow({ className, onClick }) {
    return (
        <div className="slick-arrow-container">
            <button className={className} onClick={onClick}>
                <SVGIcon name="chevron" flip /> Previous
            </button>
        </div>
    );
}

function NextArrow({ className, onClick }) {
    return (
        <div className="slick-arrow-container">
            <button className={className} onClick={onClick}>
                Next <SVGIcon name="chevron" />
            </button>
        </div>
    );
}

class LystSlider extends Component {
    render() {
        // TODO whether to show carousel based on the number of productCards

        const settings = {
            speed: 500,
            slidesToShow: 5,
            slidesToScroll: 4,
            infinite: false,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            arrow: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ],
            ...this.props.settings
        };

        return <Slider {...settings}>{this.props.children}</Slider>;
    }
}

export default LystSlider;

const arrowPropTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
};

const arrowDefaultPropTypes = {
    className: "",
    onClick: () => {}
};

PrevArrow.propTypes = arrowPropTypes;
NextArrow.propTypes = arrowPropTypes;

PrevArrow.defaultProps = arrowDefaultPropTypes;
NextArrow.defaultProps = arrowDefaultPropTypes;

LystSlider.propTypes = {
    children: PropTypes.array.isRequired,
    settings: PropTypes.object
};

LystSlider.defaultProps = {
    settings: {}
};
